<mat-sidenav-container class="app-container">
  <mat-sidenav #sidenav [class.mat-elevation-z4]="true">
    <div class="sidenav-content">
      <!-- The year sub-level of the chain list, one entry per year that actually has chains.
           A year is a NAVIGATION target, not an additive filter: it sets `?year=` and drops the
           list's other filters, and the parent item — which carries no query params — is what
           clears it again. `queryParams: 'subset'` is what keeps exactly one year highlighted. -->
      <ng-template #yearItems let-link>
        @for (facet of chainYears(); track facet.year) {
          <a
            mat-list-item
            class="submenu-item year-item"
            [routerLink]="link"
            [queryParams]="{ year: facet.year }"
            routerLinkActive="activated"
            [attr.aria-label]="('filter_by_year_tr' | translate) + ': ' + facet.year"
            [routerLinkActiveOptions]="{
              paths: 'exact',
              queryParams: 'subset',
              matrixParams: 'ignored',
              fragment: 'ignored',
            }"
          >
            {{ facet.year }}
            <span class="count">({{ facet.count }})</span>
          </a>
        }
      </ng-template>

      <div class="nav-scroll">
        <mat-nav-list>
          @if (selection && selection.company && selection.site) {
            <div data-tour="risk-radar-nav-parent">
              <a
                mat-list-item
                class="nav-toggle"
                data-tour="risk-radar-nav"
                routerLinkActive="selected"
                [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="['/company', selection.company.id, 'site', selection.site.id]"
              >
                {{ 'supply_chains_tr' | translate }}
              </a>

              @if (mode === AppMode.EUDR_RISK) {
                <a
                  mat-list-item
                  class="submenu-item"
                  [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'chain']"
                  [class.activated]="isChainBuilderActive('chain')"
                >
                  <div class="circle-number">1</div>
                  {{ 'Supply_Chain_Builder_tr' | translate }}
                </a>
                <ng-container
                  *ngTemplateOutlet="
                    yearItems;
                    context: { $implicit: ['/company', selection.company.id, 'site', selection.site.id, 'chain'] }
                  "
                />
                @if (!isFeatureHidden('risk') || isEvaluationRoute) {
                  <a
                    mat-list-item
                    class="submenu-item"
                    [class.disabled]="isFeatureDisabled('risk') && !isEvaluationRoute"
                    [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'evaluation']"
                    routerLinkActive="activated"
                    [class.activated]="isEvaluationRoute"
                    [class.selected]="isEvaluationRoute"
                  >
                    <div class="circle-number">2</div>
                    {{ 'evaluations_tr' | translate }}
                    @if (isFeatureDisabled('risk') && !isEvaluationRoute) {
                      <mat-icon>arrow_circle_up</mat-icon>
                    }
                  </a>
                }
                @if (!isFeatureHidden('risk')) {
                  <a
                    mat-list-item
                    class="submenu-item"
                    [class.disabled]="isFeatureDisabled('risk')"
                    [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'archive']"
                    routerLinkActive="activated"
                  >
                    <div class="circle-number">3</div>
                    {{ 'Report_Archive_tr' | translate }}
                    @if (isFeatureDisabled('risk')) {
                      <mat-icon>arrow_circle_up</mat-icon>
                    }
                  </a>
                }
              }
            </div>

            @if (!isFeatureHidden('eudr')) {
              <div data-tour="traces-nav-parent">
                <a
                  mat-list-item
                  class="nav-toggle"
                  data-tour="traces-nav"
                  [class.disabled]="isFeatureDisabled('eudr')"
                  [class.selected]="isTracesDetailRoute"
                  [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'traces-eudr']"
                >
                  {{ 'EUDR_Traces_tr' | translate }}
                  @if (isFeatureDisabled('eudr')) {
                    <mat-icon>arrow_circle_up</mat-icon>
                  }
                </a>

                @if (mode === AppMode.EUDR_TRACES) {
                  <a
                    mat-list-item
                    class="submenu-item"
                    [class.disabled]="isFeatureDisabled('eudr')"
                    [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'traces-eudr', 'drafts']"
                    routerLinkActive="activated"
                  >
                    <div class="circle-number">1</div>
                    {{ 'DRAFTS_tr' | translate }}
                  </a>
                  <a
                    mat-list-item
                    class="submenu-item"
                    [class.disabled]="isFeatureDisabled('eudr')"
                    [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'traces-eudr', 'archive']"
                    routerLinkActive="activated"
                  >
                    <div class="circle-number">2</div>
                    {{ 'Archive_tr' | translate }}
                  </a>
                }
              </div>
            }

            @if (!isFeatureHidden('ppwr')) {
              <div data-tour="ppwr-nav-parent">
                <a
                  mat-list-item
                  class="nav-toggle"
                  data-tour="ppwr-nav"
                  (click)="moveFocusOutside($event)"
                  [class.disabled]="isFeatureDisabled('ppwr')"
                  [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'ppwr']"
                >
                  {{ 'PPWR_tr' | translate }}
                  @if (isFeatureDisabled('ppwr')) {
                    <mat-icon>arrow_circle_up</mat-icon>
                  }
                </a>

                @if (mode === AppMode.PPWR) {
                  <a
                    mat-list-item
                    class="submenu-item"
                    [class.disabled]="isFeatureDisabled('ppwr')"
                    [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'ppwr', 'chain']"
                    [class.activated]="isChainBuilderActive('ppwr')"
                  >
                    <div class="circle-number">1</div>
                    {{ 'PPWR_chains_tr' | translate }}
                  </a>
                  <ng-container
                    *ngTemplateOutlet="
                      yearItems;
                      context: { $implicit: ['/company', selection.company.id, 'site', selection.site.id, 'ppwr', 'chain'] }
                    "
                  />
                  <a
                    mat-list-item
                    class="submenu-item"
                    [class.disabled]="isFeatureDisabled('ppwr')"
                    [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'ppwr', 'evaluation']"
                    routerLinkActive="activated"
                  >
                    <div class="circle-number">2</div>
                    {{ 'PPWR_evaluations_tr' | translate }}
                  </a>
                  <a
                    mat-list-item
                    class="submenu-item"
                    [class.disabled]="isFeatureDisabled('ppwr')"
                    [routerLink]="['/company', selection.company.id, 'site', selection.site.id, 'ppwr', 'declaration']"
                    routerLinkActive="activated"
                  >
                    <div class="circle-number">3</div>
                    {{ 'PPWR_declarations_tr' | translate }}
                  </a>
                }
              </div>
            }
          } @else {
            <a mat-list-item [routerLink]="['/']" routerLinkActive="activated">
              {{ 'Dashboard_tr' | translate }}
            </a>
          }
        </mat-nav-list>
      </div>

      @if (profile) {
        <mat-divider></mat-divider>
        <button type="button" class="user-menu-button" data-testid="user-menu-button" [matMenuTriggerFor]="userProfileMenu">
          <div class="avatar">{{ avatarInitials }}</div>
          <div class="details">
            <div class="name">{{ profile.name || profile.email }}</div>
            @if (profile.name && profile.email) {
              <div class="email">{{ profile.email }}</div>
            }
          </div>
        </button>

        <mat-menu #userProfileMenu="matMenu" class="user-profile-menu">
          <button type="button" mat-menu-item [routerLink]="['/user']">
            <mat-icon>person</mat-icon>
            <span>{{ 'Account_tr' | translate }}</span>
          </button>

          <button type="button" mat-menu-item [routerLink]="['/team']">
            <mat-icon>groups</mat-icon>
            <span>{{ 'Your_Team_tr' | translate }}</span>
          </button>
          <mat-divider></mat-divider>
          @if (manageLink; as link) {
            @if (documentInboxLink; as inboxLink) {
              <button
                type="button"
                mat-menu-item
                data-testid="document-inbox-menu-item"
                [routerLink]="inboxLink"
                [queryParams]="{ tab: 'uploaded' }"
              >
                <mat-icon>library_books</mat-icon>
                <span>{{ 'Document_Inbox_tr' | translate }}</span>
              </button>
            }
            <button mat-menu-item type="button" (click)="openCanvasManager()">
              <mat-icon>schema</mat-icon>
              <span>{{ 'manage_canvas_tr' | translate }}</span>
            </button>
            <mat-divider></mat-divider>
          }

          @if (manageLink; as link) {
            <button type="button" mat-menu-item [routerLink]="link">
              <mat-icon>settings</mat-icon>
              {{ 'Manage_Company_tr' | translate }}
            </button>
            <mat-divider></mat-divider>
          }

          <button type="button" (click)="logout()" mat-menu-item>
            <mat-icon>logout</mat-icon>
            {{ 'Logout_tr' | translate }}
          </button>

          @if (authService.isImpersonated) {
            <button type="button" (click)="switchBack()" mat-menu-item style="background-color: #fdd">
              <mat-icon>sync_alt</mat-icon>
              {{ 'switch_back_to_tr' | translate }}
              <div class="username">{{ authService.user?.impersonated }}</div>
            </button>
          }

          <mat-divider></mat-divider>

          <div class="version">
            <h5>App-Version</h5>
            {{ version }}
          </div>
        </mat-menu>
      }
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <main>
      <ng-content></ng-content>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
